module.exports = __webpack_public_path__ + "img/add-liquidity.4dfa52c4.svg";